import React from 'react'
import {
  TextInput,
  SimpleForm,
  required,
  Create,
  FileInput,
  FileField,
  useNotify,
  useRedirect,
  SelectInput,
} from 'react-admin'

import { Grid, Paper, Typography, makeStyles } from '@material-ui/core'
import { slugValidate } from 'utils/formValidations'

import { ResourceSelector, Tooltip } from 'components'

const useStyles = makeStyles({
  container: {
    width: '100%',
  },
  gridContainer: {
    width: '100%',
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
  paperContainer: {
    padding: 16,
  },
})

export const CreateForm = (props: any) => {
  const redirect = useRedirect()
  const notify = useNotify()
  const classes = useStyles()
  const {
    formTitle = '',
    shouldRedirect = true,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
    toolbar = <></>,
    aside = <></>,
    ...rest
  } = props

  const onSuccess = () => {
    notify('post_successfully')
    if (shouldRedirect) redirect(props.basePath)
    onSubmitSuccess()
  }

  const onFailure = (error: any) => {
    onSubmitFailure(error)
    notify('post_failed', 'warning')
  }

  return (
    <Create
      aside={aside}
      {...rest}
      onSuccess={onSuccess}
      onFailure={onFailure}
      className={classes.container}
    >
      <SimpleForm
        warnWhenUnsavedChanges
        className={classes.formContainer}
        toolbar={toolbar}
      >
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={2}
          className={classes.gridContainer}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Paper className={classes.paperContainer}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  {formTitle}
                </Typography>
                <hr />
              </Grid>

              <Grid container spacing={2} direction="column">
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'attachments.title'}>
                    <TextInput
                      fullWidth
                      label="Título"
                      source="title"
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'attachments.description'}>
                    <TextInput
                      fullWidth
                      label="Descrição"
                      source="description"
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <hr />
                  <Typography variant="h6" color="textSecondary" gutterBottom>
                    Upload do arquivo
                  </Typography>
                  <Typography color="textSecondary" gutterBottom>
                    A seguir, defina o caminho onde o arquivo será salvo no
                    servidor:
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <Tooltip title={'attachments.type'}>
                    <SelectInput
                      fullWidth
                      label="Tipo de material"
                      source={'type'}
                      choices={[
                        { id: 'amendment', name: 'Ementa' },
                        { id: 'courseware', name: 'Material didático' },
                        {
                          id: 'course-exercise',
                          name: 'Exercício de conclusão',
                        },
                        {
                          id: 'complementary-material',
                          name: 'Material complementar',
                        },
                      ]}
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <Tooltip title={'attachments.complementary_type'}>
                    <SelectInput
                      fullWidth
                      label="Tipo de conteúdo vinculado"
                      source="complementary_type"
                      choices={[
                        { id: 'ask', name: 'Pergunte' },
                        { id: 'especiais', name: 'Especiais' },
                        { id: 'estudos-de-caso', name: 'Estudo de caso' },
                        { id: 'liveclass', name: 'Liveclass' },
                        { id: 'medialab', name: 'Medialab' },
                        { id: 'pre-estreia', name: 'Pré Estreia' },
                        { id: 'series', name: 'Series' },
                        { id: 'to-the-point', name: 'To the point' },
                      ]}
                      validate={[required('Obrigatório')]}
                      externalLoading={false}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'attachments.content_name'}>
                    <ResourceSelector
                      fullWidth
                      label="Curso/Série"
                      resource="cms/grouper/courses"
                      source="content_name"
                      optionValue="slug"
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'attachments.content_type'}>
                    <TextInput
                      fullWidth
                      label="Slug da Semana+Aula"
                      source="content_type"
                      validate={[required('Obrigatório'), slugValidate]}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'attachments.path'}>
                    <FileInput
                      source="files"
                      label="Arquivo"
                      accept="image/*, application/pdf"
                      placeholder={<p>Clique aqui ou arraste um arquivo</p>}
                      validate={[required('Obrigatório')]}
                    >
                      <FileField source="src" title="title" />
                    </FileInput>
                  </Tooltip>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  )
}
